var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.Button,_vm._b({attrs:{"color":_setup.color,"text-color":_setup.textColor},on:{"click":function($event){return _vm.$emit('click', $event)}}},'Button',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }